import api from "../api";

export const ONBOARDING_STATUSES: api.OnboardingStatus[] = [
  "FETCHING_DATA",
  "SCREENING_CONFIG",
  "SIGNATURE_CONFIG",
  "SIGNATURE_EMAILS",
  "READY",
];
